// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1z0hU","ranges":"BmiRanges_ranges__2sQBx"};